export default __webpack_public_path__ + "static/media/step1.2385837b.svg";